<template>
    <input-wrapper
        class="textarea-input"
        v-bind="{ label, state, helpText }"
    >
        <template #default="{ id }">
            <b-form-textarea
                v-bind="{ state, name, id, type, placeholder, required, autocomplete }"
                rows="4"
                v-model="inputValue"
            />
        </template>
    </input-wrapper>
</template>

<script>
    import InputWrapper from '../InputWrapper/InputWrapper';
    import { BFormTextarea } from 'bootstrap-vue';
    import TextInput from '../TextInput/TextInput';

    export default {
        name: 'textarea-input',

        components: { InputWrapper, BFormTextarea },

        mixins: [TextInput],
    };
</script>
